import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Alert } from "@mui/lab";
import { Button, Collapse } from "@mui/material";
import React from "react";
import { MESApiService } from "../../services";
import { AuthContext } from "../AuthContext";

export const LoginAsGuest = () => {
	const [showError, setShowError] = React.useState(false);
	const [error, setError] = React.useState<any>(undefined);

	const { saveUserData } = React.useContext(AuthContext);

	const apiService = new MESApiService();
	const loginAsGuest = async (e: any) => {
		e.preventDefault();
		const response = await apiService.authenticate("public", "public");
		if (apiService.hasErrors) {
			setShowError(true);
			setError(apiService.error);
		} else {
			saveUserData(response);
		}
	};
	return (
		<>
			<Collapse in={showError}>
				<Alert
					severity="error"
					variant="filled"
					onClose={() => {
						setShowError(false);
						setError(undefined);
					}}
				>
					<strong>Bad credentials</strong>
					<p>
						{error === undefined
							? "There was an error"
							: error.internalError.message === undefined
								? error.internalError
								: error.internalError.message}
					</p>
				</Alert>
			</Collapse>
			<Button
				fullWidth
				variant="contained"
				color="primary"
				sx={{
					padding: (theme) => theme.spacing(1.2),
					fontWeight: 600,
					transition: "all 0.3s ease",
					"&:hover": {
						transform: "translateY(-2px)",
						boxShadow: (theme) => theme.shadows[4],
					},
					backgroundColor: "#479DC4",
					color: "white",
				}}
				role="button"
				onClick={loginAsGuest}
				startIcon={
					<PersonOutlineIcon
						sx={{
							marginRight: (theme) => theme.spacing(1),
						}}
					/>
				}
			>
				Guest Access
			</Button>
		</>
	);
};
